import { AtomsModule } from '../atoms/atoms.module';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { MenuItemsComponent } from './menu-items/menu-items.component';
import { MenuSectionComponent } from './menu-section/menu-section.component';
import { NgModule } from '@angular/core';
import { ProgressIndicatorsComponent } from './progress-indicators/progress-indicators.component';
import { RouterModule } from '@angular/router';
import { PreviousYearComparisonComponent } from './previous-year-comparison/previous-year-comparison.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GenericModalComponent } from './generic-modal/generic-modal.component';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { ModalStepperComponent } from './modal-stepper/modal-stepper.component';
import { MatStepperModule } from '@angular/material/stepper';
import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
@NgModule({
  imports: [CommonModule, RouterModule, AtomsModule, TranslateModule, MatTooltipModule,
    MatDialogModule, MatStepperModule, MatMenuModule, MatButtonModule
  ],
  declarations: [
    MenuItemsComponent,
    MenuSectionComponent,
    ProgressIndicatorsComponent,
    FooterComponent,
    PreviousYearComparisonComponent,
    GenericModalComponent,
    ModalStepperComponent,
    DropdownMenuComponent
  ],
  exports: [
    AtomsModule,
    MenuItemsComponent,
    MenuSectionComponent,
    ProgressIndicatorsComponent,
    FooterComponent,
    PreviousYearComparisonComponent,
    GenericModalComponent,
    ModalStepperComponent,
    MatStepperModule,
    DropdownMenuComponent
  ],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { autoFocus: 'dialog', restoreFocus: true }
    }
  ]
})
export class MoleculesModule {}
